'use strict';

angular.module('risevision.apps.services', [
  'risevision.common.header'
]);
angular.module('risevision.apps.controllers', [
  'risevision.common.config'
]);
angular.module('risevision.apps.directives', [
  'risevision.common.components.scrolling-list'
]);
